import { render, staticRenderFns } from "./searchLabelsV.vue?vue&type=template&id=505ab82b&scoped=true&"
import script from "./searchLabelsV.vue?vue&type=script&lang=js&"
export * from "./searchLabelsV.vue?vue&type=script&lang=js&"
import style0 from "./searchLabelsV.vue?vue&type=style&index=0&id=505ab82b&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505ab82b",
  null
  
)

export default component.exports